export default "__VITE_ASSET__LhtOT8Kw__"